/**
 * @name Lang
 * @type {string}
 * @description used to defined langs types
 */
export declare type Langs = "en" | "ar";

/**
 * @name AppLang
 * @enum {string}
 * @description used to defined langs variables
 */
export enum AppLang {
  EN = "en",
  AR = "ar",
}
